import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const HorizontalScroll = ({ children, size, grid, constant, dropdownActive, hideScrollbar, classes }) => {
  const horizontalScrollClass = classNames(`horizontal-scroll horizontal-scroll--${size}`, classes, {
    'horizontal-scroll--grid': grid,
    'horizontal-scroll--constant': constant,
    'horizontal-scroll--dropdown-active': dropdownActive,
    'horizontal-scroll--hide-scrollbar': hideScrollbar,
  });

  return (
    <div className={horizontalScrollClass}>
      {children}
    </div>
  );
};

HorizontalScroll.propTypes = {
  children: PropTypes.object.isRequired,
  size: PropTypes.string,
  grid: PropTypes.bool,
  constant: PropTypes.bool,
  dropdownActive: PropTypes.bool,
  hideScrollbar: PropTypes.bool,
  classes: PropTypes.string,
};

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./library/app/components/Global/Containers/HorizontalScroll.js